/**
 * Farbpalette nach der Landeskarte der Schweiz (swisstopo LK25/LK100).
 * Nachempfunden anhand der Kartenblätter, nicht offiziell – alle Werte hier
 * zentral anpassbar.
 */
export const C = {
  // Grundflächen: die Landeskarte druckt auf Weiss
  paper: '#FFFFFF',
  settlement: '#E4E1D8',
  farmland: '#FBFBF6',
  grass: '#E9F1DB',
  forest: '#CFE5B4',
  forestEdge: '#B4D199',
  tree: '#4E7C3A',
  treeConifer: '#3C6630',
  scrub: '#E3EFCF',
  rock: '#EDEAE2',
  sand: '#F7F0DC',
  glacier: '#EAF6FB',

  // Wasser
  water: '#C3E2F2',
  waterEdge: '#4D9BC4',
  river: '#5AA8CE',
  waterLabel: '#2D7FA6',

  // Bauten: in der Landeskarte schwarz gefuellt, ohne Trennlinie -
  // aneinandergebaute Haeuser verschmelzen dort zu einer Masse
  building: '#1E1C19',

  // Strassen – Werte aus den swisstopo-Kartenkacheln ausgemessen:
  // Autobahn kräftiges Amber mit dunkelbraunem Rand, Hauptstrasse lachsrosa,
  // Nebenstrasse blassgelb, Quartierstrasse weiss mit dunklem Rand
  motorway: '#F8B838',
  motorwayCase: '#6B4A08',
  trunk: '#F8C038',
  trunkCase: '#7A5610',
  primary: '#F2A892',
  primaryCase: '#B5674E',
  secondary: '#F8D86A',
  secondaryCase: '#9A7A28',
  tertiary: '#FFFFFF',
  tertiaryCase: '#7D7668',
  minor: '#FFFFFF',
  minorCase: '#6E685C',
  service: '#FFFFFF',
  serviceCase: '#9A9488',
  track: '#4A463E',
  path: '#6B655A',
  rail: '#C81818',
  railLight: '#D04038',
  aeroway: '#EDEAE2',

  // Höhenlinien
  contour: '#C79A6B',
  contourMain: '#A8703C',
  contourLabel: '#8A5E30',

  // Wanderwege (Landeskarte: rot gestrichelt)
  hiking: '#CC3A2B',

  // Grenzen
  borderCountry: '#8E6AA0',
  borderCanton: '#A98BB5',

  // Schrift
  ink: '#1A1915',
  inkSoft: '#56524A',
  halo: '#FFFFFF',
  // swisstopo stellt Beschriftung nicht frei: die Buchstaben liegen direkt auf
  // Wald, Hoehenlinie und Gebaeude. 0 schaltet den Halo ab, das Luftbild
  // hebt ihn weiter unten wieder an.
  haloWidth: 0,
  peak: '#5A4F3E',

  // POI-Akzent
  poi: '#7A4E24',
  favorite: '#141414'
};

// Source Sans 3: humanistische Grotesk in der Tradition von Frutiger/Univers,
// OFL-lizenziert. Glyphen erzeugt tools/build-glyphs.mjs, ausgeliefert unter /fonts/.
// Genau ein Name je Stapel: unsere Glyphen liegen als statische Dateien, und
// ein Verzeichnis "A,B" gibt es dort nicht - Rueckfallschriften koennte nur ein
// Glyph-Server zusammensetzen.
/**
 * Schwarzweiss-Variante. Bewusst von Hand gesetzt statt gerechnet: eine reine
 * Entsättigung macht Lachsrosa und Gelb zum selben Grau. Hier trägt stattdessen
 * die Helligkeit die Hierarchie, wie auf der grauen Landeskarte.
 */
export const GREY = {
  paper: '#FFFFFF',
  settlement: '#ECECEC',
  farmland: '#FAFAFA',
  grass: '#F2F2F2',
  forest: '#DEDEDE',
  forestEdge: '#C2C2C2',
  tree: '#7E7E7E',
  treeConifer: '#616161',
  scrub: '#E7E7E7',
  rock: '#E9E9E9',
  sand: '#F1F1F1',
  glacier: '#F6F6F6',

  water: '#E3E3E3',
  waterEdge: '#8C8C8C',
  river: '#9C9C9C',
  waterLabel: '#6B6B6B',

  building: '#1A1A1A',

  motorway: '#C6C6C6',
  motorwayCase: '#3A3A3A',
  trunk: '#D2D2D2',
  trunkCase: '#4C4C4C',
  primary: '#DADADA',
  primaryCase: '#585858',
  secondary: '#E6E6E6',
  secondaryCase: '#6C6C6C',
  tertiary: '#FFFFFF',
  tertiaryCase: '#7E7E7E',
  minor: '#FFFFFF',
  minorCase: '#8C8C8C',
  service: '#FFFFFF',
  serviceCase: '#A4A4A4',
  track: '#4A4A4A',
  path: '#6E6E6E',
  rail: '#262626',
  railLight: '#5C5C5C',
  aeroway: '#E9E9E9',

  contour: '#C0C0C0',
  contourMain: '#949494',
  contourLabel: '#6E6E6E',

  hiking: '#5A5A5A',

  borderCountry: '#8E8E8E',
  borderCanton: '#AFAFAF',

  ink: '#1A1A1A',
  inkSoft: '#5A5A5A',
  halo: '#FFFFFF',
  haloWidth: 0,
  peak: '#4A4A4A',

  poi: '#4A4A4A',
  favorite: '#141414'
};

/**
 * Umschaltbare Paletten des Kartenbilds. Auf dem Luftbild ist die Vorlage
 * ein Foto statt einer Kartengrundlage - dort traegt die Schrift doch einen
 * Halo, sonst verschwindet sie in dunklen Waeldern und Schattenhaengen.
 */
export const PALETTES = { farbig: C, sw: GREY, luftbild: { ...C, haloWidth: 1 } };

export const FONT = ['Source Sans 3 Regular'];
export const FONT_BOLD = ['Source Sans 3 Bold'];
export const FONT_ITALIC = ['Source Sans 3 Italic'];
